(function () {
  const MOBILE_BREAKPOINT = 481;
  const SCROLL_AMOUNT = 90;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function scrollToActiveOption(container) {
    if (!container) return;
    const activeOption = container.querySelector('input[type="radio"]:checked')?.closest('.formOptn');
    if (!activeOption) return;

    requestAnimationFrame(() => {
      activeOption.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    });
  }

  function initProductOptionSliders() {
    document.querySelectorAll('.product-form__input .formOptns-slider').forEach((wrapper) => {
      const container = wrapper.querySelector('.formOptns');
      if (!container) return;

      if (isMobile()) {
        wrapper.classList.add('formOptns-slider--active');
        container.classList.add('formOptns--mobile-scroll');
        scrollToActiveOption(container);
      } else {
        wrapper.classList.remove('formOptns-slider--active');
        container.classList.remove('formOptns--mobile-scroll');
      }
    });
  }

  window.initProductOptionSliders = initProductOptionSliders;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const prevBtn = target.closest('.formOptns-slider__arrow--prev');
    const nextBtn = target.closest('.formOptns-slider__arrow--next');
    if (!prevBtn && !nextBtn) return;

    const wrapper = (prevBtn || nextBtn).closest('.product-form__input .formOptns-slider');
    const container = wrapper?.querySelector('.formOptns');
    if (!container) return;

    event.preventDefault();
    container.scrollBy({
      left: prevBtn ? -SCROLL_AMOUNT : SCROLL_AMOUNT,
      behavior: 'smooth',
    });
  });

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function bindVariantChangeListener() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(initProductOptionSliders, 120);
    });
  }

  onReady(() => {
    initProductOptionSliders();
    bindVariantChangeListener();
  });

  document.addEventListener('product-info:loaded', () => {
    setTimeout(initProductOptionSliders, 0);
  });

  window.addEventListener('load', initProductOptionSliders);
  window.addEventListener('resize', initProductOptionSliders);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
    const container = event.target.closest('.product-form__input .formOptns');
    if (!container) return;
    scrollToActiveOption(container);
  });
})();
